import _ from 'lodash';

export function toDbFieldName(stringInput: string): string {
	return _.snakeCase(stringInput).toUpperCase();
}

export function snakeToPascalCase(stringInput: string): string {
	return stringInput.split('_').map(_.capitalize).join('');
}

export function toCamelCase(strings: string[]) {
	return strings.map((val) => `${val[0].toLowerCase()}${val.substring(1)}`);
}

export function objectToCamelCaseShallow(object: Record<string, any>) {
	return Object.keys(object).reduce((a, c) => {
		a[c[0].toLowerCase() + c.substring(1)] = object[c];

		return a;
	}, {} as any);
}

export function multiLangStringCompare(str1: string, str2: string) {
	return new Intl.Collator(['cs', 'de', 'sk', 'en', 'fr']).compare(str1, str2);
}
export function insertFromPosition(origin: string | null, inserted: string, position: number) {
	const originDefault = origin || '';

	return originDefault.substring(0, position) + inserted + originDefault.substring(position);
}

export function camelize(str: string) {
	return str.replace(/(?:^\w|[A-Z_-]|\b\w|\s+)/g, (match, index) => {
		if (/\s+|[_-]/.test(match)) return '';
		return index === 0 ? match.toLowerCase() : match.toUpperCase();
	});
}

export function formatDecimalValue(value: Number): string {
	if (Number.isNaN(value)) {
		return value.toString();
	}
	const val = parseFloat(value.toString().replace(',', ''));
	const stringValue = val.toString();
	const decimalIndex = stringValue.indexOf('.');
	const decimalPlaces = decimalIndex !== -1 ? stringValue.length - decimalIndex - 1 : 0;
	return val.toFixed(decimalPlaces > 2 ? 2 : decimalPlaces)
		.replace(/\d(?=(\d{3})+(\.|$))/g, '$&,');
}
